import { useMediaQuery, Theme } from '@material-ui/core';

const useIsDesktop = (): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

export const useIsSmall = (): boolean => useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

export default useIsDesktop;
